// removed by extract-text-webpack-plugin
module.exports = {"title":"xRts_","content":"lCeRY"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/components/Offline/Offline.scss
// module id = 214
// module chunks = 0 1